import { Component, OnInit } from "@angular/core";
import { ClientService } from "src/app/services/clients/client.service";
import { CommonMessages } from "src/app/shared/messages/messages.enum";
import { BaseComponent } from "../../base.component";
import { AppConstants } from "src/app/_helpers/app.constants";
import { Location } from "@angular/common";
import { NgxSpinnerService } from "ngx-spinner";
import { CampaignBuilderService } from "src/app/services/segmentation/campaign-builder.service";
import {
  JourneyBuilderTableStateService,
  UsersFilters,
} from "./journey-list-table.service";
import {
  debounceTime,
  distinctUntilChanged,
  map,
  pairwise,
  skip,
  startWith,
  take,
} from "rxjs/operators";
import { Subscription } from "rxjs";
import { TableState } from "src/app/services/base-table-state.service";
import { MasterService } from "src/app/services/master/master.service";
@Component({
  selector: "app-journey-list",
  // standalone: true,
  // imports: [],
  templateUrl: "./journey-list.component.html",
  styleUrls: ["./journey-list.component.scss"],
})
export class JourneyListComponent extends BaseComponent implements OnInit {
  currentUser: any;
  companyID: number = 0;
  domainID: number | null = 0;
  journeyID: number | null = 0; // new journey filter
  isAllowed: boolean;
  public JourneyObj: any = [];
  domainData: any = [];
  journeyData: any[] = []; // dropdown options
  AppConstants: AppConstants;
  totalCount: number = 0;
  page = 1;
  limit = 10;
  skip = 0;
  getJourneyObj: any = [];
  private sub = new Subscription();
  private isDefaultFilters(filters: UsersFilters): boolean {
    return (
      filters.companyID === null &&
      filters.domainID === null &&
      filters.journeyID === null
    );
  }
  constructor(
    private campaignBuilderService: CampaignBuilderService,
    private spinner: NgxSpinnerService,
    private clientService: ClientService,
    public location: Location,
    public tableState: JourneyBuilderTableStateService,
    public master: MasterService,
  ) {
    super();
  }

  private handleInitialLoad(state: TableState<UsersFilters>) {
    if (this.isDefaultFilters(state.filters)) {
      return;
    }

    const filters = state.filters;

    this.companyID = filters.companyID;
    this.domainID = filters.domainID;
    this.journeyID = filters.journeyID;
    this.page = state.pageIndex;
    this.limit = state.pageSize;

    if (this.companyID) {
      this.getBusinessDomain();
      this.getCompanyJourneyType();
      this.getJourneyListData(this.companyID);
    }

    if (state.pageIndex !== 1 || state.pageSize !== 10) {
      this.page = state.pageIndex;
      this.limit = state.pageSize;
    }
  }

  private handleStateChanges(
    prevState: TableState<UsersFilters>,
    currState: TableState<UsersFilters>,
  ) {
    const prevFilters = prevState.filters;
    const currFilters = currState.filters;

    if (this.isDefaultFilters(currState.filters)) {
      return;
    }

    // Company Changed
    if (prevFilters.companyID !== currFilters.companyID) {
      // this.companyID = currFilters.companyID;
      // reset or adopt domain/journey filters when company changes
      // this.domainID = currFilters.domainID;
      // this.journeyID = currFilters.journeyID;
      // fetch domains and journeys for the new company
      this.getBusinessDomain();
      this.getCompanyJourneyType();
      this.getJourneyListData(this.companyID);
      this.domainID = 0;
      this.journeyID = 0;
    }

    // Domain Changed
    if (prevFilters.domainID !== currFilters.domainID) {
      this.domainID = currFilters.domainID;
      // reload journeys for current company with new domain filter
      if (this.companyID) {
        this.getJourneyListData(this.companyID);
      }
    }

    // Journey Changed
    if (prevFilters.journeyID !== currFilters.journeyID) {
      this.journeyID = currFilters.journeyID;
      if (this.companyID) {
        this.getJourneyListData(this.companyID);
      }
    }

    // Pagination Changed
    if (
      prevState.pageIndex !== currState.pageIndex ||
      prevState.pageSize !== currState.pageSize
    ) {
      this.page = currState.pageIndex;
      this.limit = currState.pageSize;
    }
    // this.getEmailTemplateData(this.companyID, 'state change');
  }

  ngOnInit() {
    this.getCompany();
    this.currentUser = JSON.parse(sessionStorage.getItem("userData"));

    // Handle state changes with pairwise to get previous and current state
    this.sub.add(
      this.tableState.state$
        .pipe(pairwise())
        .subscribe(([prev, curr]) => this.handleStateChanges(prev, curr)),
    );
    // Handle FIRST load separately
    this.sub.add(
      this.tableState.state$
        .pipe(take(1))
        .subscribe((state) => this.handleInitialLoad(state)),
    );
    // Search changes (debounced)
  }

  // getCompany() {
  //   let self = this;
  //   this.clientService.getBUCompanies().subscribe(data => {
  //     console.log("data",data);

  //     self.getJourneyObj = data.data;
  //     this.companyID = self.getJourneyObj[0].customer_id;
  //     this.getJourneyListData(this.companyID);
  //   }, error => {
  //   });
  // }
  getCompany() {
    let self = this;
    this.clientService.getBUCompanies().subscribe(
      (data) => {
        self.getJourneyObj = data.data;
        self.hydrateWorkingCompany(self, (id) => { self.onCompanyChange({ target: { value: id }, value: id }); });

        this.getJourneyObj = this.getJourneyObj.sort((a, b) => {
          return a.customer_company_name.localeCompare(b.customer_company_name);
        });
      },
      (error) => {},
    );
  }

  // onCompanyChange(event:any){
  //   this.companyID = Number((event.target as HTMLSelectElement).value);
  //   this.getJourneyListData(this.companyID)
  // }

  onCompanyChange(event: any) {
    const value = Number((event.target as HTMLSelectElement).value);
    this.tableState.updateFilters({
      companyID: value,
      domainID: this.domainID,
      journeyID: this.journeyID,
    });
  }

  onJourneyChange(event: any) {
    const value = Number((event.target as HTMLSelectElement).value);
    this.journeyID = value;
    this.tableState.updateFilters({ journeyID: value });
  }

  clearFilter() {
    this.journeyID = 0;
    this.tableState.updateFilters({ domainID: 0, journeyID: 0 });
    this.page = 1;
    this.limit = 10;
    this.skip = 0;
    this.totalCount = 0;
  }

  // On journey status toggle Change
  updateJourneyStatus(journey: any) {

    const newStatus: boolean = journey.isactive;
    const cid = this.companyID;
    const jid = journey.id;
    

    this.confirmationDialogService
      .confirm(
        CommonMessages.confirmationTitle,
        !newStatus ? CommonMessages.activeConfirmation : CommonMessages.inactiveConfirmation,
        "Yes",
        "No",
      )
      .then((confirmed) => {
        if (confirmed) {
          this.ngxSpinnerService.show();
          this.campaignBuilderService
            .updateJourneyStatus(cid, jid, !newStatus)
            .subscribe(
              (data) => {
                this.ngxSpinnerService.hide();
                journey.isactive = !journey.isactive;
              },
              (error) => {
                console.log("updateJourneyStatus error:", error);
                this.ngxSpinnerService.hide();
              },
            );
        }
      })
      .catch(() =>{
         console.log(CommonMessages.dialogDismissMessage)
        //  journey.isactive = !journey.isactive;

      });
  }
  //Update Journey Status
  setJourneyUpdate(cid: any, jid: any, journey: any, newStatus: boolean) {
    let self = this;
    this.ngxSpinnerService.show();
    this.campaignBuilderService
      .updateJourneyStatus(cid, jid, newStatus)
      .subscribe(
        (data) => {
          // on success update local value and optionally refresh list
          if (data && data.status) {
            journey.isactive = newStatus;
          } else {
            // revert toggle if backend indicates failure
            journey.isactive = !newStatus;
          }
          this.ngxSpinnerService.hide();
        },
        (error) => {
          // revert toggle on error as well
          journey.isactive = !newStatus;
          this.ngxSpinnerService.hide();
        },
      );
  }

  getCompanyJourneyType() {
    this.ngxSpinnerService.show();
    this.clientService.getAllJourney(this.companyID).subscribe(
      (data) => {
        if (data.status) {
          this.journeyData = data?.rows;
          this.journeyData = this.journeyData.sort((a, b) => {
            return a.journey_name.localeCompare(b.journey_name);
          });
          this.ngxSpinnerService.hide();
        } else {
          this.journeyData = [];
          this.ngxSpinnerService.hide();
        }
      },
      (error) => {
        console.log(error);
        this.ngxSpinnerService.hide();
      },
    );
  }

  onDomainChange(event: any) {
    const value = Number((event.target as HTMLSelectElement).value);
    this.domainID = value;
    this.tableState.updateFilters({ domainID: value });
  }

  getBusinessDomain() {
    let self = this;
    if (!this.companyID) return;
    this.master.getBusinessDomain(100, 0, this.companyID).subscribe(
      (data) => {
        self.domainData = data?.data?.rows || [];
      },
      (error) => {
        console.log(error);
      },
    );
  }

  //Fetch Journey List Data
  getJourneyListData(cid: any) {
    let self = this;
    this.skip = (this.page - 1) * this.limit;
    this.ngxSpinnerService.show();
    this.campaignBuilderService
      .getJourneyRecords(
        cid,
        this.limit,
        this.skip,
        this.domainID,
        this.journeyID,
      )
      .subscribe(
        (data) => {
          if (data.status) {
            if (data.data.rows == null) {
              self.JourneyObj = [];
            } else {
              self.JourneyObj = data.data.rows;
              console.log(this.JourneyObj);
            }
            self.totalCount = data.data.total;
          } else {
            self.JourneyObj = [];
          }
          this.ngxSpinnerService.hide();
        },
        (error) => {
          this.ngxSpinnerService.hide();
        },
      );
  }

  //Edit Client data
  editJourneyRecord(id) {
    this.router.navigate(["/corporate/create-journey"], {
      queryParams: { jid: id, cid: this.companyID },
    });
  }

  //Delete Client Data
  deleteJourneyRecord(id) {
    this.confirmationDialogService
      .confirm(
        CommonMessages.confirmationTitle,
        CommonMessages.deleteConfirmation,
        "Yes",
        "No",
      )
      .then((confirmed) => {
        if (confirmed) {
          this.ngxSpinnerService.show();
          this.campaignBuilderService
            .deleteJourneyById(this.companyID, id)
            .subscribe(
              (data) => {
                if (data.status) {
                  this.getJourneyListData(this.companyID);
                  setTimeout(() => {
                    this.toastrService.success("Journey Deleted Successfully.");
                  }, 1000);
                } else {
                  this.toastrService.error(data.message);
                }
                this.ngxSpinnerService.hide();
              },
              (error) => {
                // console.log(error);
                this.ngxSpinnerService.hide();
              },
            );
        }
      })
      .catch(() => console.log(CommonMessages.dialogDismissMessage));
  }

  //Copy Journey Template
  cloneJourneyTemplate(id: any, name: string) {
    this.confirmationDialogService
      .confirm(
        CommonMessages.confirmationTitle,
        CommonMessages.cloneConfirmation,
        "Yes",
        "No",
        "sm",
        true,
        name,
      )
      .then((result: any) => {
        const confirmed =
          typeof result === "boolean" ? result : result?.confirmed;
        const inputValue =
          typeof result === "object" ? result?.inputValue : null;
        if (confirmed) {
          const payload = {
            cjb_name: inputValue,
            campaign_journey_builder_id: id,
          };
          this.ngxSpinnerService.show();
          this.clientService
            .cloneJourneyTemplate(payload, this.companyID)
            .subscribe(
              (data) => {
                if (data.status) {
                  this.toastrService.success(data.message);
                }
                this.getJourneyListData(this.companyID);
                this.ngxSpinnerService.hide();
              },
              (error) => {
                console.log(error);
                this.ngxSpinnerService.hide();
              },
            );
        }
      })
      .catch(() => console.log(CommonMessages.dialogDismissMessage));
  }

  getCompanyData(page: number) {
    this.page = page;
    this.getJourneyListData(this.companyID);
  }
}
